import React, { useState } from 'react';
import { API } from '@/App';
import { BookOpen, Loader2 } from 'lucide-react';
import axios from 'axios';

export function ClassroomToggle({ sectionKey }) {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchClassroom = async () => {
    if (content) { setOpen(o => !o); return; }
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/classroom-content/${sectionKey}`, { withCredentials: true });
      setContent(data.content || 'Not available yet.');
      setOpen(true);
    } catch { setContent('Classroom content unavailable.'); setOpen(true); }
    finally { setLoading(false); }
  };

  return (
    <div className="mt-4" data-testid={`classroom-${sectionKey}`}>
      <button
        onClick={fetchClassroom}
        className="flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-semibold border border-amber-300 text-amber-700 bg-amber-50 hover:bg-amber-100 transition-all font-body"
        disabled={loading}
        data-testid={`classroom-toggle-${sectionKey}`}
      >
        {loading ? <Loader2 size={14} className="animate-spin" /> : <BookOpen size={14} />}
        {open ? 'Hide' : 'Show'} PhD Classroom Mode
      </button>
      {open && content && (
        <div className="mt-3 bg-[#FFF8E1] rounded-2xl p-5 border border-amber-200 fade-in">
          <h4 className="font-bold text-amber-800 text-sm mb-3 uppercase tracking-wider flex items-center gap-2 font-body">
            <BookOpen size={16} /> PhD Classroom: Step-by-Step Formulas
          </h4>
          <pre className="text-xs text-amber-900 whitespace-pre-wrap leading-relaxed font-mono">{content}</pre>
        </div>
      )}
    </div>
  );
}
